import { z } from 'zod';
export const ChannelVisibility = z.enum(['public', 'private']);
const name = z.string().trim().min(1).max(80);
const topic = z.string().trim().max(300);
export const CreateChannelRequest = z.object({
    kind: z.enum(['text', 'voice']).optional(),
    visibility: ChannelVisibility,
    name,
    topic: topic.optional(),
    /** Private channels only: people added next to the creator. */
    memberIds: z.array(z.uuid()).max(100).default([]),
});
export const UpdateChannelRequest = z
    .object({ name: name.optional(), topic: topic.nullable().optional() })
    .refine((body) => body.name !== undefined || body.topic !== undefined, { message: 'Nothing to update' });
export const AddMembersRequest = z.object({
    userIds: z.array(z.uuid()).min(1).max(100),
});
/** Which new messages notify the reader: every one, mentions only, or none. */
export const NotifyLevel = z.enum(['all', 'mentions', 'mute']);
export const SetNotifyLevelRequest = z.object({ level: NotifyLevel });
//# sourceMappingURL=channels.js.map